import { render, staticRenderFns } from "./DepartmentUsers.vue?vue&type=template&id=10d534b6"
import script from "./DepartmentUsers.vue?vue&type=script&lang=js"
export * from "./DepartmentUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports